import { render } from "./VacancyLinkCard.vue?vue&type=template&id=5271e6e4&scoped=true"
import script from "./VacancyLinkCard.vue?vue&type=script&lang=js"
export * from "./VacancyLinkCard.vue?vue&type=script&lang=js"

import "./VacancyLinkCard.vue?vue&type=style&index=0&id=5271e6e4&lang=scss&scoped=true"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5271e6e4"]])

export default __exports__